<mat-card class="feedback-questions-content-item" *ngIf="currentAnswer">
  <div class="item-headline">
    <div class="title large bold" [innerHTML]="title"></div>
    <div class="responses-count">
      {{ 'translations.diagnostics.labels.feedbackAdditionalContentResponses' | transloco: { number: feedbackProviderResponsesCount } }}
    </div>
  </div>

  <div class="slider-wrapper" role="group" aria-label="Slider responses">
    <div class="slider-track" aria-hidden="true"></div>

    <div class="ticks">
      <span class="tick" *ngFor="let tick of ticks" [style.left.%]="((tick - min) / (max - min)) * 100">{{ tick }}</span>
    </div>

    <div class="end-labels" aria-hidden="true">
      <span class="end-label left">{{ leftLabel }}</span>
      <span class="end-label right">{{ rightLabel }}</span>
    </div>

    <div class="buckets">
      <div
        class="bucket"
        *ngFor="let bucket of buckets"
        [ngClass]="bucket.sizeClass"
        [style.left.%]="bucket.leftPercent"
        role="list"
        [attr.aria-label]="'Responses at ' + bucket.value"
      >
        <ul class="avatar-stack" role="list">
          <li class="avatar-item" *ngFor="let marker of bucket.markers | slice: 0 : bucket.visibleCount; let i = index" role="listitem">
            <div
              class="avatar-item-inner"
              matTooltip="{{ marker.score | number: '1.0-0' }}"
              matTooltipPosition="above"
              tabindex="0"
              [attr.aria-label]="marker.label + ' scored ' + (marker.score | number: '1.0-0')"
            >
              <img class="avatar" [src]="marker.image ?? 'assets/profile_image.png'" [alt]="marker.label" />
            </div>

            <div class="avatar-name" title="{{ marker.label }}">{{ marker.label }}</div>
          </li>
        </ul>

        <div *ngIf="bucket.markers.length > bucket.visibleCount" class="more-badge" aria-hidden="false">
          +{{ bucket.markers.length - bucket.visibleCount }}
        </div>
      </div>
    </div>
  </div>
</mat-card>
